import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { Box, VStack, Heading, Text, Button } from '@chakra-ui/react';
// Descarga animaciones de LottieFiles.com y ponlas en tu proyecto
import winnerAnimation from '../assets/trophy.json'; 
import finalistAnimation from '../assets/trophy.json';

export default function VictoryAnimation({ victoryData, onComplete }) {
  const isWinner = victoryData.place === 1;

  useEffect(() => {
    // Limpia la bandera en la base de datos en cuanto el componente se monta
    onComplete();
  }, [onComplete]);

  return (
    <Box position="fixed" top="0" left="0" w="100vw" h="100vh" bg="blackAlpha.800" zIndex="overlay">
      <VStack h="full" justify="center" spacing={4}>
        <Box w={{ base: '90%', md: '500px' }}>
          <Lottie animationData={isWinner ? winnerAnimation : finalistAnimation} loop={false} />
        </Box>
        <Heading color="white">{isWinner ? '¡FELICIDADES, LO LOGRASTE!' : '¡GRAN TORNEO, FINALISTA!'}</Heading>
        <Text color="gray.200">Lograste el {isWinner ? '1er' : '2do'} lugar en el torneo "{victoryData.tournamentName}"</Text>
        <Button colorScheme="yellow" onClick={onComplete}>Cerrar</Button>
      </VStack>
    </Box>
  );
}